/* Gerido pelo BukProd — reaplicado após cada atualização do tema.
   Pré-selecciona o filtro "Em stock" nas coleções. */
(function () {
  "use strict";

  // Não mexer para crawlers: queremos que o Google indexe a coleção completa,
  // não a versão filtrada.
  var ua = navigator.userAgent || "";
  if (/bot|crawl|spider|slurp|bingpreview|lighthouse|headless/i.test(ua)) return;

  if (location.pathname.indexOf("/collections/") !== 0) return;

  var qs = location.search || "";

  // Já há uma escolha do utilizador em curso — não interferir.
  if (qs.indexOf("filter.") !== -1) return;
  if (qs.indexOf("sort_by") !== -1) return;
  if (qs.indexOf("page=") !== -1) return;

  // Se o utilizador desligar o filtro, não o voltamos a impor nesta coleção
  // durante a sessão. Sem isto era impossível ver os esgotados.
  var key = "bukprod:stock:" + location.pathname;
  try {
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, "1");
  } catch (e) {
    // sessionStorage bloqueado (modo privado): melhor não redirecionar de todo,
    // senão entramos em ciclo.
    return;
  }

  var sep = qs ? "&" : "?";
  location.replace(location.pathname + qs + sep + "filter.v.availability=1");
})();

/* ---------------------------------------------------------------------------
   Texto de entrega nos cartões de produto.

   O tema escreve «Enviamos em 24 horas» ao lado do stock (é o
   deliverytime_in_stock do snippets/product-deliverytime.liquid). É texto fixo:
   diz o mesmo às 10h de terça e às 23h de domingo — e no segundo caso é uma
   promessa que o armazém não cumpre.

   Passa a anunciar o dia da entrega em vez do envio: «Receba amanhã» quando é
   mesmo amanhã, «Receba na quarta» quando não é. Uma compra às 18h de segunda
   já não apanha a expedição de hoje, sai na terça e chega na quarta; à sexta,
   seja a que horas for, a entrega é na segunda.

   A previsão vale para Portugal continental, que é para onde vai a esmagadora
   maioria das encomendas. Para as ilhas o prazo é maior e o texto fica optimista:
   é assumido de propósito, não é um caso por tratar.

   Porquê aqui e não em Liquid: a decisão depende da hora, e o Liquid é
   renderizado uma vez e servido de cache. Uma página gerada às 15h continuaria
   a prometer «Receba amanhã» às 22h. No browser a hora é sempre a de agora.

   A hora é a de Lisboa e não a do visitante: quem decide se a encomenda sai
   hoje é o armazém, não quem está a comprar de outro fuso.
--------------------------------------------------------------------------- */
(function () {
  "use strict";

  // Expedimos no próprio dia o que entra até às 16h30, e a entrega chega no dia
  // útil seguinte.
  var CORTE_HORA = 16;
  var CORTE_MINUTO = 30;

  var TEXTO_ORIGINAL = "Enviamos em 24 horas";

  // A voz é a mesma que o tema usa no contador da ficha do produto
  // ("Receba já amanhã!"). Duas maneiras de dizer a mesma promessa na mesma
  // página fazem a loja parecer dois sítios.
  //
  // E os dias levam o "-feira": em português escreve-se segunda-feira, não
  // segunda. Sábado e domingo não levam.
  var TEXTO_AMANHA = "Receba já amanhã!";
  var PREFIXO_DIA = "Receba já na ";
  var SUFIXO_DIA = "!";
  var DIAS_NOME = ["domingo", "segunda-feira", "terça-feira", "quarta-feira",
                   "quinta-feira", "sexta-feira", "sábado"];

  // A true, o dia seguinte diz «Receba amanhã» em vez de «Receba na terça».
  var USAR_AMANHA = true;

  // Rede de segurança: se a entrega cair a mais de uma semana — uma ponte de
  // feriados longa — o nome do dia deixa de identificar a data sem ambiguidade,
  // e mais vale não arriscar.
  var TEXTO_SEM_PREVISAO = "Envio em 24h";
  var LIMITE_NOME_DIA = 6;
  var LIMITE_PROCURA = 14;

  // Feriados sem expedição nem entrega, em ISO (aaaa-mm-dd). Vazio = só conta o
  // fim de semana. Ficam à mão de propósito: os móveis (Sexta-Feira Santa, Páscoa,
  // Corpo de Deus) mudam de data todos os anos.
  var FERIADOS = [];

  // Só mexemos no texto de fábrica e no nosso. O deliverytime_in_stock pode vir
  // de um metafield por produto, e aí o texto foi escolhido para aquele artigo —
  // reescrevê-lo era apagar informação verdadeira. A lista tem de incluir tudo o
  // que nós próprios escrevemos, senão a revisão periódica não reconhecia o
  // texto que já lá está e a previsão ficava congelada.
  var CONHECIDOS = [TEXTO_ORIGINAL, TEXTO_AMANHA, TEXTO_SEM_PREVISAO];
  for (var d = 0; d < DIAS_NOME.length; d++) {
    CONHECIDOS.push(PREFIXO_DIA + DIAS_NOME[d] + SUFIXO_DIA);
  }

  // Textos que este ficheiro já escreveu antes de a loja mudar de voz. Sem
  // eles, a revisão periódica deixava de reconhecer o que ele próprio tinha
  // posto, e uma página aberta desde ontem ficava com a promessa congelada.
  var DIAS_ANTIGOS = ["domingo", "segunda", "terça", "quarta", "quinta", "sexta", "sábado"];
  CONHECIDOS.push("Receba amanhã");
  for (var v = 0; v < DIAS_ANTIGOS.length; v++) CONHECIDOS.push("Receba na " + DIAS_ANTIGOS[v]);

  function emLisboa(quando) {
    // O Intl devolve os campos já convertidos: evita contas com offsets e trata
    // sozinho da mudança para a hora de verão.
    var partes = new Intl.DateTimeFormat("en-GB", {
      timeZone: "Europe/Lisbon",
      weekday: "short",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hourCycle: "h23"
    }).formatToParts(quando);

    var p = {};
    for (var i = 0; i < partes.length; i++) p[partes[i].type] = partes[i].value;

    var dias = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
    return {
      dia: dias[p.weekday],
      minutos: parseInt(p.hour, 10) * 60 + parseInt(p.minute, 10),
      data: p.year + "-" + p.month + "-" + p.day
    };
  }

  function diaUtil(t) {
    if (t.dia === 0 || t.dia === 6) return false;
    return FERIADOS.indexOf(t.data) === -1;
  }

  function diaRelativo(base, n) {
    return emLisboa(new Date(base.getTime() + n * 86400000));
  }

  function diasAteEntrega(hoje) {
    // Contamos a partir do meio-dia UTC da data de hoje em Lisboa. Somar dias à
    // hora a que estamos partia-se nos dois dias do ano em que o relógio muda:
    // num deles o dia local tem 25 horas, e +24h cai na mesma data.
    var base = new Date(hoje.data + "T12:00:00Z");

    // Expedição: hoje, se ainda é dia útil e a encomenda apanha o corte. Senão,
    // o próximo dia útil.
    var expedicao = 0;
    if (!diaUtil(hoje) || hoje.minutos >= CORTE_HORA * 60 + CORTE_MINUTO) {
      expedicao = 1;
      while (expedicao <= LIMITE_PROCURA && !diaUtil(diaRelativo(base, expedicao))) expedicao++;
    }

    // Entrega: o dia útil a seguir ao da expedição.
    var entrega = expedicao + 1;
    while (entrega <= LIMITE_PROCURA && !diaUtil(diaRelativo(base, entrega))) entrega++;

    if (entrega > LIMITE_NOME_DIA) return null;
    return { dias: entrega, dia: diaRelativo(base, entrega).dia };
  }

  function textoDaEntrega(hoje) {
    var e = diasAteEntrega(hoje);
    if (!e) return TEXTO_SEM_PREVISAO;
    if (e.dias === 1 && USAR_AMANHA) return TEXTO_AMANHA;
    return PREFIXO_DIA + DIAS_NOME[e.dia] + SUFIXO_DIA;
  }

  /* A promessa de entrega, para quem a queira fora dos cartões do tema.
   *
   * Quem a quer é a camada de pesquisa, que desenha cartões próprios e tem de
   * dizer exactamente o mesmo que a loja diz nos dela. A alternativa era copiar
   * para lá o corte das 16:30, os feriados e a contagem dos dias úteis — e no
   * dia em que uma dessas regras mudasse, ficavam duas lojas a prometer coisas
   * diferentes na mesma página.
   *
   * Devolve null quando não há previsão fiável. Quem chamar tem de aguentar o
   * null: este ficheiro pode não estar carregado, ou o Intl pode falhar. */
  window.BUKPROD_ENTREGA = function () {
    try {
      var hoje = emLisboa(new Date());
      if (typeof hoje.dia !== "number" || isNaN(hoje.minutos)) return null;
      return textoDaEntrega(hoje);
    } catch (e) {
      return null;
    }
  };

  /* Um aluguer nunca promete entrega.
   *
   * Um aluguer combina-se, levanta-se e devolve-se — não segue por
   * transportadora no dia seguinte. A promessa é uma só para a página inteira
   * e não sabe distinguir um cabo de um aluguer, por isso a distinção faz-se
   * aqui, elemento a elemento.
   *
   * A regra é a mesma do resto do projecto (`_product_is_rental`): a palavra
   * no título. Sobe-se até seis níveis à procura de um título ou de uma
   * ligação para a ficha — chega para apanhar o cartão na coleção e a coluna
   * de informação na ficha do produto, sem depender de nomes de classes do
   * tema, que mudam entre versões. */
  function dentroDeAluguer(no) {
    var p = no;
    for (var i = 0; i < 6 && p && p !== document.body; i++) {
      if (p.querySelector) {
        var t = p.querySelector("h1, h2, h3, a[href*='/products/']");
        if (t && /aluguer/i.test(t.textContent || "")) return true;
      }
      p = p.parentNode;
    }
    return false;
  }

  /* Na ficha de um aluguer, o contador do tema também se cala.
   *
   * Esse bloco é do Xtra e o texto dele vem das traduções, não passa por aqui
   * — estava a prometer "Receba já amanhã!" num pack de aluguer de 180 EUR.
   * Esconde-se em vez de se reescrever: a marcação é dele e tem um contador
   * lá dentro. */
  function calarContadorDeAluguer() {
    var h1 = document.querySelector("h1");
    if (!h1 || !/aluguer/i.test(h1.textContent || "")) return;
    /* `style.display` e não `hidden`: o atributo vale como estilo do
       browser, e qualquer `display` que o tema ponha ganha-lhe. Com
       `hidden = true` o contador continuava à vista numa ficha de aluguer. */
    var contadores = document.querySelectorAll(".f8pr-shipping-timer");
    for (var i = 0; i < contadores.length; i++) contadores[i].style.display = "none";
  }

  /* O contador do tema a dizer o mesmo que os cartões.
   *
   * O bloco "Receba já amanhã! Encomende dentro de: ..." é do Xtra e o texto
   * vem das traduções — é fixo, não calcula nada. Numa sexta-feira dizia
   * "amanhã" ao lado de um "Receba já na segunda-feira!" calculado por nós, e a
   * ficha ficava a discordar de si própria.
   *
   * Mexe-se só no <span class="strong">, que é onde vive a promessa. O resto da
   * linha — o "Encomende dentro de:" e o contador — é dele e fica intacto. */
  function acertarContadorDoTema(novo) {
    var blocos = document.querySelectorAll(".f8pr-shipping-timer .strong");
    for (var i = 0; i < blocos.length; i++) {
      if (blocos[i].textContent.trim() !== novo) blocos[i].textContent = novo;
    }
  }

  /* A ficha é de um aluguer? A regra é a do resto do projecto: a palavra no
     título. Aqui basta o <h1>, que na ficha é o nome do produto. */
  function fichaDeAluguer() {
    var h1 = document.querySelector("h1");
    return !!(h1 && /aluguer/i.test(h1.textContent || ""));
  }

  /* Troca o texto DENTRO dos nós de texto, e não o innerHTML.
     Os botões do tema têm ícones e <span> de estado lá dentro; reescrever o
     innerHTML apagava-os e o botão deixava de mostrar o "a processar". */
  function trocarTexto(raiz, procura, novoTexto) {
    var pilha = [raiz];
    while (pilha.length) {
      var no = pilha.pop();
      for (var i = 0; i < no.childNodes.length; i++) {
        var f = no.childNodes[i];
        if (f.nodeType === 3) {
          if (procura.test(f.nodeValue)) f.nodeValue = f.nodeValue.replace(procura, novoTexto);
        } else if (f.nodeType === 1) {
          pilha.push(f);
        }
      }
    }
  }

  /* Um aluguer não se compra já, reserva-se.
   *
   * O «Compre já!» é o botão de pagamento imediato da Shopify: salta o carrinho
   * e vai direito a pagar. Num aluguer isso é uma encomenda feita sem combinar
   * datas nem caução — exactamente a que alguém vai ter de desfazer ao
   * telefone. Esconde-se.
   *
   * O «Adicionar ao carrinho» fica, porque é por aí que os alugueres desta loja
   * passam de facto, mas passa a chamar-se «Reservar»: é o que a pessoa está
   * mesmo a fazer. */
  function arrumarBotoesDeAluguer() {
    if (!fichaDeAluguer()) return;

    var rapidos = document.querySelectorAll(
      ".overlay-dynamic_buy_button, shopify-accelerated-checkout, "+
      ".shopify-payment-button, #shopify-buyer-consent"
    );
    for (var i = 0; i < rapidos.length; i++) rapidos[i].style.display = "none";

    var botoes = document.querySelectorAll(
      'button[name="add"], form[action*="/cart/add"] button, .product-form button'
    );
    for (var j = 0; j < botoes.length; j++) {
      if (/adicionar ao carrinho/i.test(botoes[j].textContent || "")) {
        trocarTexto(botoes[j], /Adicionar ao carrinho/i, "Reservar");
      }
    }
  }

  function aplicar() {
    calarContadorDeAluguer();
    arrumarBotoesDeAluguer();

    var novo;
    try {
      var hoje = emLisboa(new Date());
      if (typeof hoje.dia !== "number" || isNaN(hoje.minutos)) return;
      novo = textoDaEntrega(hoje);
    } catch (e) {
      // Sem Intl fiável mais vale deixar o texto do tema do que arriscar a
      // promessa errada.
      return;
    }

    // .overlay-valid é o ramo «há stock» do snippet; o .overlay-error (esgotado)
    // fica intocado de propósito.
    acertarContadorDoTema(novo);

    var caixas = document.querySelectorAll(".stock.overlay-valid");
    for (var i = 0; i < caixas.length; i++) {
      if (dentroDeAluguer(caixas[i])) continue;
      var filhos = caixas[i].children;
      for (var j = 0; j < filhos.length; j++) {
        if (filhos[j].tagName !== "SPAN") continue;
        var nos = filhos[j].childNodes;
        for (var k = 0; k < nos.length; k++) {
          // Mexer no nó de texto e não no innerHTML: o <i class="icon-check"> e
          // o tooltip .s1tt são irmãos dele e têm de sobreviver.
          if (nos[k].nodeType !== 3) continue;
          var atual = nos[k].nodeValue.trim();
          if (CONHECIDOS.indexOf(atual) === -1) continue;
          if (atual !== novo) nos[k].nodeValue = nos[k].nodeValue.replace(atual, novo);
          break;
        }
      }
    }
  }

  /* ---------------------------------------------------- recomendados ---- */

  /* Três sugestões por baixo da promessa de entrega, na ficha do produto.
   *
   * A ordem é a que a loja pediu: primeiro o que ENCAIXA (complementares,
   * escolhidos à mão na app Search & Discovery), depois o que é PARECIDO
   * (relacionados, escolhidos pelo algoritmo da Shopify).
   *
   * Nunca fica vazio. Se ninguém tiver escrito complementares para este
   * produto — que é o caso hoje em toda a loja — preenche-se com relacionados.
   * Um bloco vazio não ensina nada a ninguém; três parecidos pelo menos
   * mostram onde a coisa vai ficar.
   *
   * Só aparece com pelo menos um produto, e só na ficha (é onde existe o
   * input escondido com o id). */
  var RECO_QUANTOS = 3;

  function idDoProduto() {
    var i = document.querySelector('input[name="product-id"]');
    if (i && i.value) return i.value;
    try {
      return window.ShopifyAnalytics.meta.product.id;
    } catch (e) {
      return null;
    }
  }

  function pedirReco(id, intencao, quantos) {
    var url = "/recommendations/products.json?product_id=" + encodeURIComponent(id) +
      "&limit=" + quantos + "&intent=" + intencao;
    return fetch(url, { headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) { return (j && j.products) || []; })
      .catch(function () { return []; });
  }

  /* O titulo vem da loja, mas passa na mesma por aqui.
     Um `&` num nome de produto chega para partir a marcacao, e nao ha razao
     para confiar em nada que se cole dentro de um `innerHTML`. */
  function escapar(s) {
    return String(s == null ? "" : s)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function euros(centimos) {
    return (centimos / 100).toFixed(2).replace(".", ",") + "\u00a0\u20ac";
  }

  /* A variante que se mete no carrinho.
     A primeira que estiver disponivel. Nao havendo nenhuma, o cartao sai sem
     botao e leva a pessoa a ficha -- melhor nao oferecer do que oferecer e
     falhar no fim. */
  function varianteDe(p) {
    var vs = p.variants || [];
    for (var i = 0; i < vs.length; i++) {
      if (vs[i] && vs[i].available && vs[i].id) return vs[i].id;
    }
    return null;
  }

  function cartaoReco(p) {
    /* O `featured_image` deste endereco e uma CADEIA, nao um objecto com
       `.url` -- ao contrario do que o /cart/add.js devolve para as linhas do
       carrinho. Escrevi `featured_image.url`, deu `undefined`, e os cartoes
       sairam todos sem imagem. */
    var img = p.featured_image || (p.images && p.images[0]) || "";
    if (img) img += (img.indexOf("?") === -1 ? "?" : "&") + "width=200";

    /* O riscado so quando e mesmo um desconto.
     *
     * Ha fichas neste catalogo com o `compare_at_price` ABAIXO do preco: a
     * primeira que abri tinha preco 150,00 e <<anterior>> 120,00. Mostrar isso
     * dava um desconto negativo por baixo de uma sugestao de compra. E a mesma
     * armadilha ja documentada no indexador da pesquisa, e a mesma regra. */
    var velho = p.compare_at_price > p.price
      ? '<s class="bukprod-reco__velho">' + euros(p.compare_at_price) + '</s> '
      : "";

    var vid = varianteDe(p);
    var botao = vid
      ? '<button type="button" class="bukprod-reco__add" data-vid="' + vid +
        '">Adicionar</button>'
      : "";

    /* O botao fica FORA da ligacao. Dentro dela, clicar nele navegava para a
       ficha antes de o carrinho saber de alguma coisa. */
    return '<div class="bukprod-reco__item">' +
      '<a class="bukprod-reco__ir" href="' + escapar(p.url) + '">' +
        (img ? '<img src="' + escapar(img) + '" alt="" loading="lazy">' : '<span></span>') +
        '<span class="bukprod-reco__nome">' + escapar(p.title) + "</span>" +
        '<span class="bukprod-reco__preco">' + velho + euros(p.price) + "</span>" +
      "</a>" + botao +
      "</div>";
  }

  /* Meter no carrinho a partir da sugestao.
   *
   * `fetch` e nao XMLHttpRequest, de proposito: a Shopify embrulha o `fetch`
   * e e por ai que avisa o tema de que o carrinho mudou. Com XHR o artigo
   * entrava mas o numero no cabecalho ficava a zero, e isso ja custou uma
   * tarde a perceber.
   *
   * E preciso refazer a gaveta: o tema desenha-a no servidor quando a pagina
   * carrega, portanto depois de metermos um artigo por fora ela abria vazia.
   */
  function meterNoCarrinhoReco(botao) {
    var vid = botao.getAttribute("data-vid");
    if (!vid || botao.disabled) return;

    var dizia = botao.textContent;
    botao.disabled = true;
    botao.textContent = "A juntar\u2026";

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error("HTTP " + r.status);
        return fetch("/cart.js", { headers: { Accept: "application/json" } });
      })
      .then(function (r) { return r.json(); })
      .then(function (carrinho) {
        contadorDaLoja(carrinho);
        refazerGaveta();
        botao.textContent = "Adicionado";
        setTimeout(function () {
          botao.textContent = dizia;
          botao.disabled = false;
        }, 1600);
      })
      .catch(function (e) {
        console.warn("[bukprod] nao consegui juntar:", e && e.message);
        botao.textContent = dizia;
        botao.disabled = false;
      });
  }

  function contadorDaLoja(carrinho) {
    var n = (carrinho && carrinho.item_count) || 0;
    var ids = ["cart-count", "cart-count--m"];
    for (var i = 0; i < ids.length; i++) {
      var el = document.getElementById(ids[i]);
      if (el) el.textContent = String(n);
    }
    var cab = document.querySelector("#cart header[data-totalqty]");
    if (cab) cab.setAttribute("data-totalqty", String(n));
  }

  function refazerGaveta() {
    var actual = document.getElementById("cart");
    if (!actual) return;
    var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    fetch(raiz + "?sections=side-cart", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (seccoes) {
        if (!seccoes || !seccoes["side-cart"]) return;
        var caixa = document.createElement("div");
        caixa.innerHTML = seccoes["side-cart"];
        var nova = caixa.querySelector("#cart");
        if (nova) actual.innerHTML = nova.innerHTML;
      })
      .catch(function () { /* fica como estava */ });
  }

  function recomendados() {
    var alvo = document.querySelector(".f8pr-shipping-timer");
    if (!alvo || document.querySelector(".bukprod-reco")) return;

    var id = idDoProduto();
    if (!id) return;

    pedirReco(id, "complementary", RECO_QUANTOS).then(function (encaixam) {
      var faltam = RECO_QUANTOS - encaixam.length;
      if (faltam <= 0) return encaixam.slice(0, RECO_QUANTOS);

      // Plano B: o algoritmo da Shopify. Pede-se mais do que falta, porque
      // pode devolver produtos que ja vieram nos complementares.
      return pedirReco(id, "related", RECO_QUANTOS + 3).then(function (parecidos) {
        var vistos = {};
        for (var i = 0; i < encaixam.length; i++) vistos[encaixam[i].id] = 1;
        var juntos = encaixam.slice();
        for (var j = 0; j < parecidos.length && juntos.length < RECO_QUANTOS; j++) {
          if (vistos[parecidos[j].id]) continue;
          vistos[parecidos[j].id] = 1;
          juntos.push(parecidos[j]);
        }
        return juntos;
      });
    }).then(function (lista) {
      if (!lista || !lista.length) return;
      var caixa = document.createElement("div");
      caixa.className = "bukprod-reco";
      caixa.innerHTML = '<p class="bukprod-reco__titulo">Sugerimos tamb\u00e9m para este artigo:</p>' +
        '<div class="bukprod-reco__fila">' + lista.map(cartaoReco).join("") + "</div>";
      alvo.parentNode.insertBefore(caixa, alvo.nextSibling);

      caixa.addEventListener("click", function (e) {
        var b = e.target.closest && e.target.closest(".bukprod-reco__add");
        if (!b) return;
        e.preventDefault();
        meterNoCarrinhoReco(b);
      });
    }).catch(function (e) {
      // Sem sugestões a ficha fica como estava. Nunca vale a pena partir uma
      // página de produto por causa de um bloco de recomendações.
      console.warn("[bukprod] recomendados:", e && e.message);
    });
  }

  /* A altura real do cabecalho, em pixeis, para o rasto de navegacao saber
     onde encostar.
     
     Nao se pode escrever a medida a mao: o cabecalho muda de altura com a
     largura da janela, com o tamanho de letra que a pessoa escolher no botao
     de acessibilidade, e com a faixa de cima a aparecer ou nao. Mede-se o
     elemento e publica-se o valor numa variavel que o CSS le. */
  var alturaCabecalho = 0;

  function medirCabecalho() {
    var topo = document.querySelector(".shopify-section-header");
    if (!topo) return;
    var h = Math.round(topo.offsetHeight);
    if (h && h !== alturaCabecalho) {
      alturaCabecalho = h;
      document.documentElement.style.setProperty("--ms-cabecalho-h", h + "px");
    }
  }

  function vigiarCabecalho() {
    var topo = document.querySelector(".shopify-section-header");
    if (!topo) return;
    medirCabecalho();

    // As letras de encomenda chegam depois do DOMContentLoaded e mudam a
    // altura em um ou dois pixeis. Medir so uma vez deixava o rasto
    // desencostado por uma frincha.
    window.addEventListener("load", medirCabecalho);

    if (window.ResizeObserver) {
      new ResizeObserver(medirCabecalho).observe(topo);
    } else {
      window.addEventListener("resize", medirCabecalho);
    }
  }

  function arrancar() {
    aplicar();
    vigiarCabecalho();
    recomendados();

    // Os cartões são redesenhados a cada filtro, ordenação ou página do tema.
    // Observamos só childList: mudar um nodeValue não dispara este observer,
    // por isso não há ciclo.
    if (window.MutationObserver) {
      new MutationObserver(function (mudancas) {
        for (var i = 0; i < mudancas.length; i++) {
          if (mudancas[i].addedNodes.length) { aplicar(); return; }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }

    // Separador deixado aberto por cima das 16h ou da meia-noite: sem isto a
    // promessa fica congelada na que estava certa à hora do carregamento.
    setInterval(aplicar, 10 * 60 * 1000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", arrancar);
  } else {
    arrancar();
  }
})();

/* ---------------------------------------------------------------------------
   Pesquisa: exigir os termos em vez de os sugerir.

   A pesquisa da Shopify, com o termo solto, faz duas coisas más ao mesmo tempo:
   soma os termos por OU em vez de os exigir todos, e alarga-os a palavras
   parecidas. Medido nesta loja, a 08/09/2026:

       megafone           72 resultados   ("megafone")           9
       megafone bateria  276 resultados   ("megafone" "bateria") 6
       coluna ativa      381 resultados   ("coluna" "ativa")    15
       cabo xlr         1000 resultados   ("cabo" "xlr")       172

   Os 72 de «megafone» incluem oito microfones — e nenhum deles tem a palavra
   megafone no título, nas tags, no tipo, na marca, na descrição ou no SEO. É a
   Shopify a casar «microfone» com «megafone» pelo «fone» que partilham.

   Pôr cada termo entre aspas desliga as duas coisas. O que se perde é a
   tolerância a gralhas — «megafona» com aspas dá zero — e é por isso que existe
   a rede: dando zero, repete-se a pesquisa como a pessoa a escreveu e diz-se-lhe
   porquê. Prefixos não se perdem, que a Shopify já não os fazia: «megaf» dá zero
   nos dois casos.

   Duas entradas, porque a pesquisa tem duas portas: o formulário (a maioria,
   sem custo nenhum) e o endereço já feito — link do dropdown, favorito, Google —
   que só se pode corrigir a chegar, com um salto.
--------------------------------------------------------------------------- */
(function () {
  "use strict";

  var MARCA = "bp";          // 1 = já pusemos aspas · 0 = rede, não voltar a pôr

  // O Google tem de indexar o que a loja responde a um termo, não a nossa
  // reescrita dele.
  var ua = navigator.userAgent || "";
  if (/bot|crawl|spider|slurp|bingpreview|lighthouse|headless/i.test(ua)) return;

  /** Cada termo entre aspas, ou null quando não se deve mexer.
   *
   *  Não se mexe em quem já escreveu aspas, nem em quem usou a sintaxe da
   *  Shopify (`title:`, `*`, AND/OR/NOT, `-fora`): essas pessoas sabem o que
   *  querem e embrulhar-lhes os termos estragava a consulta. */
  function comAspas(q) {
    var texto = (q || "").trim();
    if (!texto || texto.indexOf('"') !== -1) return null;
    if (/[:*()]/.test(texto)) return null;
    var termos = texto.split(/\\s+/).filter(Boolean);
    if (!termos.length) return null;
    for (var i = 0; i < termos.length; i++) {
      if (/^(AND|OR|NOT)$/i.test(termos[i]) || termos[i].charAt(0) === "-") return null;
    }
    return termos.map(function (t) { return '"' + t + '"'; }).join(" ");
  }

  /* --- Porta 1: o formulário. Sai já com aspas, sem salto nenhum. --------- */
  document.addEventListener("submit", function (ev) {
    var form = ev.target;
    if (!form || form.tagName !== "FORM") return;
    var accao = form.getAttribute("action") || "";
    if (accao.indexOf("/search") === -1) return;

    var campo = form.querySelector('input[name="q"]');
    if (!campo) return;
    var novo = comAspas(campo.value);
    if (!novo) return;

    campo.value = novo;
    if (!form.querySelector('input[name="' + MARCA + '"]')) {
      var marca = document.createElement("input");
      marca.type = "hidden";
      marca.name = MARCA;
      marca.value = "1";
      form.appendChild(marca);
    }
  }, true);

  /* --- Porta 2: já cá dentro. O salto custa um carregamento, e por isso só
         se dá a quem chegou sem passar pelo formulário. -------------------- */
  if (location.pathname.indexOf("/search") !== 0) return;

  var params = new URLSearchParams(location.search);
  var q = params.get("q");
  if (!q) return;
  var marca = params.get(MARCA);

  function ir(novoQ, novaMarca) {
    params.set("q", novoQ);
    params.set(MARCA, novaMarca);
    // `replace` e não `assign`: o botão de voltar tem de sair da pesquisa, não
    // passear pelas nossas reescritas dela.
    location.replace(location.pathname + "?" + params.toString());
  }

  if (marca === null) {
    var apertado = comAspas(q);
    if (apertado) { ir(apertado, "1"); return; }
    marca = "0";                      // nada a apertar aqui: segue como está
  }

  /* As aspas são para a Shopify, não para quem procura.
   *
   *  Depois do salto, a caixa fica a dizer «"megafone"» e o título «Resultados
   *  da pesquisa para ""megafone""». Quem escreveu não pôs aspas nenhumas e não
   *  tem de perceber porque é que elas apareceram.
   *
   *  Limpa-se o que se vê e não o endereço: os links da paginação e dos filtros
   *  são desenhados pelo tema a partir da consulta a sério, e reescrever a barra
   *  de endereço arriscava que o clique seguinte fosse buscar os 72 outra vez. */
  function limparAspas() {
    var visto = q.replace(/"/g, "").trim();
    if (!visto || visto === q) return;

    var caixas = document.querySelectorAll('input[name="q"]');
    for (var i = 0; i < caixas.length; i++) {
      if (caixas[i].value.indexOf('"') !== -1) caixas[i].value = visto;
    }

    // O tema põe o termo dentro das suas próprias aspas, por isso o que aqui
    // aparece é «""megafone""». Trocar o termo inteiro resolve os dois casos.
    var titulos = document.querySelectorAll("h1, h2, h3");
    for (var j = 0; j < titulos.length; j++) {
      var t = titulos[j];
      if (t.children.length) continue;          // não desmontar títulos com marcação
      if (t.textContent.indexOf(q) === -1) continue;
      t.textContent = t.textContent.split(q).join(visto);
    }
  }

  // A rede. O tema escreve a contagem no wrapper — não é preciso perguntar
  // outra vez ao servidor para saber que deu zero.
  function arrancar() {
    var caixa = document.querySelector("[data-standard-results-count]");
    if (!caixa) return;
    if (parseInt(caixa.getAttribute("data-standard-results-count"), 10) !== 0) return;
    var solto = q.replace(/"/g, "").trim();
    if (!solto || solto === q) return;
    try { sessionStorage.setItem("bukprod:pesquisa-alargada", solto); } catch (e) {}
    ir(solto, "0");
  }

  /* O aviso, na página alargada: quem procurou «megafona» tem de perceber que
     o que está a ver não é o que escreveu.

     O aviso entra na COLUNA dos resultados, não na caixa que a contém. A caixa
     (`.m6cl`) é a linha do tema: uma flex-row invertida com duas colunas — os
     resultados de um lado, o <aside> dos filtros do outro — e `> * {width:100%}`
     em cima. Pendurar lá um terceiro filho fazia dele uma terceira coluna: o
     aviso encostado à direita, com a grelha de produtos espremida a meia
     largura e meio ecrã em branco ao lado. */
  function avisar() {
    var termo;
    try { termo = sessionStorage.getItem("bukprod:pesquisa-alargada"); } catch (e) { return; }
    if (!termo || termo !== q) return;
    try { sessionStorage.removeItem("bukprod:pesquisa-alargada"); } catch (e) {}
    var caixa = document.querySelector("[data-standard-results-count]");
    if (!caixa) return;
    if (caixa.querySelector(".bukprod-pesquisa-alargada")) return;

    // A coluna dos resultados é o primeiro filho que não é o <aside> dos filtros.
    var coluna = null;
    for (var i = 0; i < caixa.children.length; i++) {
      if (caixa.children[i].tagName !== "ASIDE") { coluna = caixa.children[i]; break; }
    }
    if (!coluna) return;

    // Logo por baixo do título: é a seguir a «Resultados da pesquisa para X»
    // que faz falta dizer que X não existe tal e qual.
    var depois = coluna.firstChild;
    for (var j = 0; j < coluna.children.length; j++) {
      if (coluna.children[j].tagName === "HEADER") {
        depois = coluna.children[j].nextSibling;
        break;
      }
    }

    var nota = document.createElement("p");
    nota.className = "bukprod-pesquisa-alargada";
    nota.textContent = "Não há nada com «" + termo + "» tal e qual. Isto é o que mais se aproxima.";
    coluna.insertBefore(nota, depois);
  }

  function agora() {
    if (marca === "1") { limparAspas(); arrancar(); }
    else avisar();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", agora);
  } else {
    agora();
  }
})();
